'use strict';

/* global $ */

class Modal {
    constructor(options) {
        this.opt = $.extend({}, {
            block: '.js-modal__block',
            close: '.js-modal__close',
        }, options);
        this.init(this.opt.selector);
    }

    init(el) {
        console.log('[ Modal/Init ]');
        let self = this;
        let $el = $(el);

        $el.find(this.opt.close).on('click', function(e) {
            e.preventDefault();
            self.closeModal();
        });

        $(this.opt.selector).on('click',function(e) {
            if (!(($(e.target).closest(self.opt.block).length > 0 ) || ($(e.target).closest(self.opt.close).length > 0))) {
                self.closeModal();
            }
        });
   }

    showModal() {
        console.log('[ Modal/Open ]');
        $(this.opt.selector).addClass('is-open');
    }

    closeModal() {
        console.log('[ Modal/Close ]');
        $(this.opt.selector).removeClass('is-open');
    }
}

export {
    Modal
};
